(function() {

    'use strict';

    angular.module('app').
    controller('CarriersController', CarriersController);

    CarriersController.$inject = ['$location', '$filter', '$rootScope', '$scope', 'Carrier', 'CarrierProfileTableService'];

    function CarriersController($location, $filter, $rootScope, $scope, Carrier, CarrierProfileTableService) {

        var vm = this;

        init();

        function init() {
            getCarriers();
        };

        function getCarriers() {
            Carrier.getCarriers(function(data) {
                vm.carrierProfiles = new CarrierProfileTableService(data).tableData;
            }, function(err) {
                console.log(err);
            });
        };
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/CarriersController.js